import { render, staticRenderFns } from "./cadpedidosvenda.vue?vue&type=template&id=69d56bf8&"
import script from "./cadpedidosvenda.vue?vue&type=script&lang=js&"
export * from "./cadpedidosvenda.vue?vue&type=script&lang=js&"
import style0 from "./cadpedidosvenda.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports